import { RelationshipBoolean, RelationType } from './general.type'
import { ApiStrength } from './product.type'

export enum MARStatus {
  ADMINISTERED = 'administered',
  WASTED = 'wasted',
  REFUSED = 'refused',
  LATE_ADMINISTERED = 'late_administered'
}

export interface MARResMock {
  id: string
  type: string
  attributes: MARAttributes
  relationships: ResRelationships
  meta: ResMeta2
}

export interface MARAttributes {
  administered_at: any
  quantity: string
  mode: string
  period_of_day: any
  scheduled_for: string
  medication_details: MedicationDetails
  created_at: string
  updated_at: string
}

export interface MedicationDetails {
  form: string
  route: string
  dosage: string
  dose_quantity: string
  dose_unit: string
  drug_name: string
  strength: string
  api_doses?: ApiStrength[]
  medication_type: string
  custom_frequency: CustomFrequency
  medication_frequency_code: string
}

export interface CustomFrequency {
  [key: string]: any
}

export interface ResRelationships {
  medication: RelationType
  encounter: RelationType
  staff: RelationType
  patient: RelationType
  // product: RelationType
}

export interface ResMeta2 {
  status: string
  last_transition: Partial<LastTransition>
}

export interface LastTransition {
  metadata: {
    note: string
    change_by: number
  }
}

export interface MARIncludedMock {
  id: string
  type: string
  attributes: Attributes
  relationships?: Relationships
  meta: Meta6
  links?: Links
}

export interface Attributes {
  quantity?: string
  dosage?: string
  form?: string
  route?: string
  once?: boolean
  start_at?: string
  end_at?: string
  medication_type?: string
  comment?: string
  ordered?: boolean
  custom_frequency?: CustomFrequency
  created_at?: string
  updated_at?: string
  first_name?: string
  last_name?: string
  gender?: string
  name?: string
  ref?: string
  encounter_type?: 'inpatient' | 'outpatient'
  purpose?: string
}

export interface Relationships {
  encounter: RelationshipBoolean
  patient: RelationType
  staff: RelationshipBoolean
  medication_frequency: RelationshipBoolean
  drug: RelationshipBoolean
  unit: RelationType
  bed: RelationType
}

export interface Meta6 {
  status?: string
  roles?: string[]
}

export interface Links {
  self: string
}
